import React from "react";
import { useSelector } from "react-redux";
import { convertToMarathiNumber } from '../components/marathiNumbers';
import { Link } from "react-router-dom";

const Careers = () => {
  // Translator Code
  const selectedLang =
    useSelector((state) => state.language.selectedLang) || "English";

  const content = {
    English: {
      title: "Career",
      breadcrumb: "HOME",
      divisionTitle: "CAREER",
      paragraph1:
        "Helpline if candidates face any problem related to admit card",
      paragraph2:
        "IBPS link and help line numbers for candidates facing problems to download call letter",
      linktitle: "Link:",
      link: "https://cgrs.ibps.in/",
      help: "Help Line:",
      helpno: "1800 222 366 / 1800 103 4566",
      links: [
        {
          _id: 1,
          name: "Link to Download Admit Card",
          url: "https://example.com/download-admit-card",
        },
        {
          _id: 2,
          name: "Link for Updating SEBC category for Open Category Candidates.",
          url: "https://example.com/update-sebc-category",
        },
        {
          _id: 3,
          name: "Link to Download Admit Card",
          url: "https://example.com/download-admit-card",
        },
        {
          _id: 4,
          name: "Link for Updating SEBC category for Open Category Candidates.",
          url: "https://example.com/update-sebc-category",
        },
      ],
    },
    मराठी: {
      title: "करिअर",
      breadcrumb: "मुख्यपृष्ठ ",
      divisionTitle: "करिअर",
      paragraph1:
        "प्रवेशपत्राबाबत कोणतीही समस्या असल्यास उमेदवारांना हेल्पलाइन",
      paragraph2:
        "कॉल लेटर डाउनलोड करण्यासाठी अडचणी येणाऱ्या उमेदवारांसाठी आयबीपीएस लिंक आणि हेल्पलाइन नंबर",
      linktitle: "लिंक:",
      link: "https://cgrs.ibps.in/",
      help: "मदत क्रमांक:",
      helpno: "१८०० २२२ ३६६ / १८०० १०३ ४५६६",
      links: [
        {
          _id: 1,
          name: "प्रवेशपत्र डाउनलोड करण्यासाठी लिंक",
          url: "https://example.com/download-admit-card",
        },
        {
          _id: 2,
          name: "SEBC वर्ग अद्ययावत करण्यासाठी लिंक (मोकळ्या वर्गासाठी उमेदवार)",
          url: "https://example.com/update-sebc-category",
        },
        {
          _id: 3,
          name: "प्रवेशपत्र डाउनलोड करण्यासाठी लिंक",
          url: "https://example.com/download-admit-card",
        },
        {
          _id: 4,
          name: "SEBC वर्ग अद्ययावत करण्यासाठी लिंक (मोकळ्या वर्गासाठी उमेदवार)",
          url: "https://example.com/update-sebc-category",
        },
      ],
    },
  };

  const t = content[selectedLang];

  return (
    <div className="flex flex-col items-center px-4 md:px-12 py-12">
      {/* Heading */}
      <div className="text-center mb-8">
        <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">
          {t.title}
        </h1>
        <p className="font-futura tracking-wider text-sm sm:text-base lg:text-[15px] font-medium mt-2">
          <span style={{ color: "#DD9827" }}>
            <Link to="/" className="hover:underline">
              {t.breadcrumb}
            </Link>{" "}/{" "}</span>
          {t.divisionTitle}
        </p>
      </div>

      {/* Text content */}
      <div className="text-left text-sm sm:text-base max-w-5xl w-full mb-8 p-2 mt-4">
        <ul className="list-none ">
          <li>{t.paragraph1}</li>
          <li>{t.paragraph2}</li>
          <li>
            {t.linktitle}{" "}
            <a
              href={t.link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline"
            >
              {t.link}
            </a>
          </li>
          <li>
            {t.help}: {t.helpno}
          </li>
        </ul>
      </div>

      {/* Table */}
      <div className="max-w-5xl w-full mb-12 bg-[#EFEDE0] rounded-xl shadow overflow-x-auto" style={{ border: "2px solid #F8D6BF" }}>
        <table className="min-w-full bg-[#EFEDE0] text-center text-black text-sm sm:text-base">
          <thead className='font-bold tracking-wide' style={{
            textShadow: '0.3px 0.3px 0 black',
          }}>
            <tr className="text-nowrap">
              <th scope="col" className="px-2 py-4 border-r-2 border-[#F8D6BF]">
                Sr. No.
              </th>
              <th scope="col" className="px-2 py-4 border-[#F8D6BF]">
                {selectedLang === "English" ? "Name" : "नाव"}
              </th>
            </tr>
          </thead>
          <tbody>
            {t.links.map((item, index) => (
              <tr
                key={item._id}
                className="text-sm sm:text-base"
              >
                <td className="px-2 py-4 border-t-2 border-r-2 border-[#F8D6BF]">
                  {selectedLang === 'मराठी' ? convertToMarathiNumber(index + 1) : `${index + 1}`}.
                </td>
                <td className="px-2 py-4 border-t-2 border-[#F8D6BF]">
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#007BFF]"
                  >
                    {item.name}
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Careers;
